import { render, staticRenderFns } from "./TextHeader.vue?vue&type=template&id=3bc1c07d&scoped=true&"
import script from "./TextHeader.vue?vue&type=script&lang=js&"
export * from "./TextHeader.vue?vue&type=script&lang=js&"
import style0 from "./TextHeader.vue?vue&type=style&index=0&id=3bc1c07d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1c07d",
  null
  
)

export default component.exports